<template>
  <Drawer title="功能丰富行业平台" v-model="openDrawer" width="700" placement='left'>
    <Row id="patsul" :gutter="30">
      <Col
        style="margin-bottom: 30px"
        span="12"
        v-for="(item, index) in plats"
        :key="index"
      >
        <a :href="item.href" target="_blank">
          <img :src="item.src" width="310"/>
          <h3>{{ item.name }}</h3>
          <p>{{ item.des }}</p></a
        >
      </Col>
    </Row>
  </Drawer>
</template>
<script>
export default {
  data() {
    return {
      openDrawer: false,
      plats: [],
    };
  },
  methods: {
    reach() {
      this.openDrawer = true;
      this.getTemp();
    },
    getTemp() {
      ///cloud-common-server-auth/system/tmpl
      this.axios({
        method: "post",
        url: this.axios.commonAuth + "/system/tmpl",
        data: {},
      }).then((res) => {
        this.loading = false;
        this.plats = [];
        var data = res.data.data;
        for (let i = 0; i < data.length; i++) {
          var obj = {
            name: data[i].name,
            src: data[i].loginBgPic,
            href: data[i].link,
            des: data[i].remark ? data[i].remark : "暂无介绍信息",
          };
          this.plats.push(obj);
        }
      });
    },
  },
};
</script>
<style>
#patsul a {
  color: #333;
}
#patsul h3 {
  margin-top: 10px;
  margin-bottom: 4px;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/sys/morePlat.vue